// React i hooks
import { memo, useCallback, useState } from "react";

// API servisi i konstante
import { ReportSearchFormValues } from "services/api/reports/types";


// Hook-ovi

// Tipovi
import { ReportSearchFilterProps } from "./types";

// UI komponente
import { TextField } from "ui/components/TextField/TextField";
import { initialReportSearchForm } from "services/api/reports/consts";
import { useTranslate } from "helpers";

const ReportSearchFilters: React.FC<ReportSearchFilterProps> = (props) => {
  const { onAddNew, onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<ReportSearchFormValues>(
    initialReportSearchForm
  );


  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    const updatedFormValues = { ...formValues, search: "" };
    setFormValues(initialReportSearchForm);
    onSearchChange(updatedFormValues);
  }, []);

  return (
    <>
      <div className="my-3">
        <div className="flex justify-between items-center gap-3">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                  {t("admin.reset")}
              </span>
            </div>
          </div>

          <div className="py-3 flex gap-2 justify-end "></div>
        </div>
      </div>
    </>
  );
};
export default memo(ReportSearchFilters);
